<template>
    <div class="IdealScheduleReport">
        <el-card>
            <h4 class="text-xl text-app-dashboard-heading">
                Ideal vs Schedule vs Actual
            </h4>
            <div class="flex justify-between py-4">
                <div>
                    <p class="text-xs font-bold">Select Location</p>
                    <el-select v-model="location" filterable placeholder="Select">
                        <el-option
                        v-for="item in 10"
                        :key="item"
                        :label="item"
                        :value="item">
                        </el-option>
                    </el-select>
                </div>
                <div>
                    <p class="text-xs font-bold">From Date</p>
                    <el-date-picker
                        v-model="start_date"
                        type="date"
                        default-value="2010-10-01"
                        placeholder="select date">
                    </el-date-picker>
                </div>
                <div>
                    <p class="text-xs font-bold">To Date</p>
                    <el-date-picker
                        v-model="end_date"
                        type="date"
                        placeholder="select date">
                    </el-date-picker>
                </div>
                <div>
                    <p class="text-xs font-bold">Department</p>
                    <el-select v-model="location" filterable placeholder="Select">
                        <el-option
                        v-for="item in 10"
                        :key="item"
                        :label="item"
                        :value="item">
                        </el-option>
                    </el-select>
                </div>
            </div>
        </el-card>
        <el-card class="my-4">
            <div class="main-table">
                <div class="table-head">
                    <table>
                        <thead>
                            <tr>
                                <th colspan="1"></th>
                                <th colspan="2">Ideal</th>
                                <th colspan="2">Schedule</th>
                                <th colspan="2">Actual</th>
                                <th colspan="2">Variance HRS</th>
                                <th colspan="2">Variance Cost</th>
                            </tr>
                            <tr>
                                <th>Store Name</th>
                                <th>Labour Hrs</th>
                                <th>Labour Cost</th>
                                <th>Labour Hrs</th>
                                <th>Labour Cost</th>
                                <th>Labour Hrs</th>
                                <th>Labour Cost</th>
                                <th>Ideal vs Actual</th>
                                <th>Schedule vs Actual</th>
                                <th>Ideal vs Actual</th>
                                <th>Schedule vs Actual</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="table-body">
                    <table>
                        <tbody>
                            <tr v-for="(item, index) in 10" :key="index">
                                <td class="font-bold">Fort</td>
                                <td>10</td>
                                <td>100</td>
                                <td>1000</td>
                                <td>10000</td>
                                <td>10</td>
                                <td>100</td>
                                <td>10%</td>
                                <td>10%</td>
                                <td>10%</td>
                                <td>20%</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </el-card>
    </div>
</template>
<script>
export default {
   name: "IdealScheduleReport",
   data() {
       return {
            location: "",
            start_date: "",
            end_date: ""
       }
   } 
}
</script>
<style lang="scss" scoped>
@import "./IdealScheduleReport.scss";
</style>